export const getImageDimensions = async (imageString) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve({ width: image.width, height: image.height });
        image.onerror = () => reject('Failed to load image');
        image.src = imageString;
    });
};
